module.exports = __webpack_public_path__ + "static/media/AVAX.3e178e42.png";